import {
    Chip,
    DialogContent,
    DialogTitle,
    Divider,
    Modal,
    ModalClose,
    ModalDialog,
    Stack,
    Typography,
    useTheme
} from "@mui/joy";
import React from "react";


const IOSInstallPromptDialogComponent = () => {
    const IOS_INSTALL_STEPS = [
        "Open the page in Safari",
        "Tap the 3 dots at the bottom to open the browser menu",
        "Tap the Share button",
        "Scroll down and tap \"Add to Home Screen\"",
        "Tap Add to confirm"
    ]

    return <Modal open={true}>
        <ModalDialog variant="outlined" role="alertdialog" size={"lg"} sx={{minWidth: {xs: "100%", sm: "35rem"}}}>
            <DialogTitle sx={{alignSelf: "center"}}>
                IOS Install Required
            </DialogTitle>

            <Divider/>

            <Stack gap={3} direction={"row"} justifyContent={"center"} alignItems={"center"}>
                <IOSMockup/>

                <Stack gap={1}>
                    {IOS_INSTALL_STEPS.map((step, index) =>
                        <Stack gap={1} direction={"row"} alignItems={"center"}>
                            <Chip variant={"solid"} color={"primary"}>
                                {index + 1}
                            </Chip>
                            <Typography level={"body-sm"} textColor={"text.primary"}>
                                {step}
                            </Typography>
                        </Stack>)}
                </Stack>

            </Stack>


            <DialogContent>
                <Typography level={"body-sm"}>
                    For the best experience on iPhone, install LinguaScore to your home screen. This enables microphone
                    access and audio playback required for the Speaking test.
                </Typography>
            </DialogContent>

        </ModalDialog>
    </Modal>
}

function IOSMockup() {
    const theme = useTheme()

    return (
        <svg width="160" height="240" viewBox="0 0 160 240" fill="none" style={{display: 'block'}}>
            {/* Phone body */}
            <rect x="1" y="1" width="158" height="238" rx="22" fill={theme.palette.background.surface}
                  stroke={theme.palette.background.level2} strokeWidth="1.5"/>

            {/* Notch */}
            <rect x="50" y="0" width="60" height="16" rx="8" fill={theme.palette.background.level2}/>

            {/* Status bar */}
            <rect x="14" y="22" width="132" height="8" rx="2" fill={theme.palette.background.level1}/>

            {/* Browser address bar */}
            <rect x="14" y="35" width="132" height="14" rx="4" fill={theme.palette.background.level2}
                  stroke={theme.palette.divider} strokeWidth="1"/>
            <text x="80" y="45" textAnchor="middle" fontSize="7" fill={theme.palette.text.primary}
                  fontFamily="system-ui">linguascores.com
            </text>

            {/* Page content area */}
            <rect x="14" y="55" width="132" height="110" rx="4" fill={theme.palette.background.level2}/>
            {/* LinguaScore logo in page */}
            <foreignObject x="50" y="60" width="64" height="64">
                <div style={{
                    width: 50,
                    height: 50,
                    background: theme.palette.primary['500'],
                    borderRadius: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img src={require("../../assets/logo_white.png")} alt="LinguaScore" width={40} height={40}
                         style={{objectFit: 'contain'}}/>
                </div>
            </foreignObject>
            <rect x="36" y="120" width="88" height="6" rx="3" fill={theme.palette.background.level3}/>
            <rect x="50" y="130" width="60" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="42" y="139" width="76" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="56" y="148" width="48" height="5" rx="2.5" fill={theme.palette.background.level3}/>

            {/* Share sheet */}
            <rect x="0" y="168" width="160" height="70" rx="0" fill={theme.palette.background.level1}/>
            <rect x="0" y="168" width="160" height="70" rx="0" fill={theme.palette.background.level1}
                  stroke={theme.palette.background.level3} strokeWidth="1"/>
            {/* Handle */}
            <rect x="66" y="174" width="28" height="3.5" rx="2" fill={theme.palette.background.level3}/>

            {/* Highlighted row: Add to Home Screen */}
            <rect x="0" y="182" width="160" height="26" fill={theme.palette.background.level2}/>
            {/* Plus-square icon */}
            <rect x="12" y="188" width="14" height="14" rx="3" fill="none" stroke={theme.palette.text.icon}
                  strokeWidth="1.4"/>
            <line x1="19" y1="192" x2="19" y2="199" stroke={theme.palette.text.icon} strokeWidth="1.4"
                  strokeLinecap="round"/>
            <line x1="15.5" y1="195.5" x2="22.5" y2="195.5" stroke={theme.palette.text.icon} strokeWidth="1.4"
                  strokeLinecap="round"/>
            <text x="32" y="198" fontSize="8.5" fill={theme.palette.text.primary} fontFamily="system-ui"
                  fontWeight="600">Add to Home Screen
            </text>

            {/* Second row */}
            <rect x="12" y="212" width="14" height="14" rx="3" fill="none" stroke="#9ca3af" strokeWidth="1.2"/>
            <text x="32" y="222" fontSize="8" fill={theme.palette.text.primary} fontFamily="system-ui">Copy</text>

            {/* Bottom safe area / home indicator */}
            <rect x="58" y="232" width="44" height="4" rx="2" fill={theme.palette.text.secondary}/>
        </svg>
    )
}


export default IOSInstallPromptDialogComponent